// reach_ui/src/components/VastGPT/ChatDrawer.js
import React from 'react'
import { Drawer, Button } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import ChatsList from './ChatsList'

const ChatDrawer = ({ isOpen, onClose, onNewChat, toggleDrawer }) => {
  return (
    <Drawer open={isOpen} onClose={onClose}>
      <Button
        onClick={() => {
          onNewChat()
          onClose()
        }}
        style={{ marginBottom: 10 }}
      >
        <Add style={{ marginRight: 5 }} />
        New chat
      </Button>
      <ChatsList toggleDrawer={toggleDrawer} />
    </Drawer>
  )
}

export default ChatDrawer
